import { render, staticRenderFns } from "./FilterAndSort.vue?vue&type=template&id=e134a7f8"
import script from "./FilterAndSort.vue?vue&type=script&lang=js"
export * from "./FilterAndSort.vue?vue&type=script&lang=js"
import style0 from "./FilterAndSort.vue?vue&type=style&index=0&id=e134a7f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports